import React from "react";
import { StringWidget } from "./StringWidget";

export function URLWidget(props) {

  const actionButtonOptions =
  {
    icon: 'globe',
    action: (value) => { 
      window.open(value, "_blank"); 
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="URLWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}